import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const SnowFlake: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="11.0819"
        y="0.99292"
        width="1.83616"
        height="22.034"
        rx="0.918082"
        fill={color}
      />
      <rect
        x="21.082"
        y="5.7063"
        width="1.83616"
        height="22.034"
        rx="0.918082"
        transform="rotate(60 21.082 5.7063)"
        fill={color}
      />
      <rect
        x="22"
        y="16.7234"
        width="1.83616"
        height="22.034"
        rx="0.918082"
        transform="rotate(120 22 16.7234)"
        fill={color}
      />
      <path
        d="M14.9771 3.96986L12.1115 6.83547L9.24584 3.96986"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.24584 20.3841L12.1114 17.5185L14.9771 20.3841"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.6393 18.8094L16.5904 14.8949L20.5049 13.846"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20.5049 10.5468L16.5904 9.49794L17.6393 5.58344"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.73371 5.58344L7.7826 9.49794L3.8681 10.5468"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.8681 13.846L7.7826 14.8949L6.73371 18.8094"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SnowFlake;
